<template>
  <v-card>
    <v-container fluid grid-list-lg>
      <v-layout style="background: #efefef">
        <v-flex sm12 md12 class="align-start">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-flex>
        <v-flex sm12 md12 v-if="!loadingBillingCS">
          <v-layout justify-space-around align-end pt-2>
            <v-spacer />
            <!-- Criar Fatura -->
            <v-tooltip
              bottom
              dark
              v-if="!this.user.group.includes('external_collection')"
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  color="tertiary"
                  small
                  icon
                  flat
                  @click.prevent="createBillingDialog = true"
                  v-on="on"
                >
                  <v-icon right>mdi-file-document-box-outline</v-icon>
                </v-btn>
              </template>
              <span color="white--text">Criar fatura</span>
            </v-tooltip>

            <!-- Reenviar Fatura -->
            <v-tooltip
              bottom
              dark
              v-if="
                billings.length > 0 &&
                !this.user.group.includes('external_collection')
              "
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  color="tertiary"
                  small
                  icon
                  flat
                  @click.prevent="resendDialog = true"
                  v-on="on"
                >
                  <v-icon right>send</v-icon>
                </v-btn>
              </template>
              <span color="white--text">Reenviar fatura</span>
            </v-tooltip>

            <!-- Alterar Vencimento -->
            <v-tooltip
              bottom
              dark
              v-if="
                billings.length > 0 &&
                !this.user.group.includes('external_collection')
              "
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  color="tertiary"
                  small
                  icon
                  flat
                  @click.prevent="changeDueDateDialog = true"
                  v-on="on"
                >
                  <v-icon right>gavel</v-icon>
                </v-btn>
              </template>
              <span color="white--text">Alterar Vencimento</span>
            </v-tooltip>

            <!-- A pedidos, não deletar botão de cancelar renegociação abaixo -->

            <!-- Cancelar Renegociação -->
            <!-- <v-tooltip bottom dark>
              <template v-slot:activator="{ on }">
                <v-btn color="tertiary" small icon flat @click.prevent="getRenegociationInvoices" v-on="on">
                  <v-icon right>mdi-calendar-remove</v-icon>
                </v-btn>
              </template>
              <span color="white--text">Cancelar negociação</span>
            </v-tooltip> -->

            <!-- Copiar Faturas Atrasadas -->
            <v-tooltip bottom dark v-if="billings.length > 0">
              <template v-slot:activator="{ on }">
                <v-btn
                  color="tertiary"
                  small
                  icon
                  flat
                  @click.prevent="copyOverdueBillings"
                  v-on="on"
                >
                  <v-icon right>content_copy</v-icon>
                </v-btn>
              </template>
              <span color="white--text">Copiar faturas atrasadas</span>
            </v-tooltip>

            <!-- Renegociar/parcelar faturas -->
            <v-tooltip bottom dark v-if="billings.length > 0">
              <template v-slot:activator="{ on }">
                <v-btn
                  color="tertiary"
                  small
                  icon
                  flat
                  @click.prevent="parcelDialog = true"
                  v-on="on"
                >
                  <v-icon right>list</v-icon>
                </v-btn>
              </template>
              <span color="white--text">Renegociar dívida</span>
            </v-tooltip>

            <v-tooltip
              bottom
              dark
              v-if="
                billings.length > 0 &&
                !this.user.group.includes('external_collection')
              "
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  color="tertiary"
                  small
                  icon
                  flat
                  @click.prevent="abonoDialog = true"
                  v-on="on"
                >
                  <v-icon right>money_off</v-icon>
                </v-btn>
              </template>
              <span color="white--text">Abonar Fatura(s)</span>
            </v-tooltip>

            <!-- Negativar Faturas -->
            <v-tooltip
              bottom
              dark
              v-if="
                user.partner_id === 'enercred' &&
                billings.length > 0 &&
                !this.user.group.includes('external_collection')
              "
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  color="tertiary"
                  small
                  icon
                  flat
                  @click.prevent="negativationDialog = true"
                  v-on="on"
                >
                  <v-icon right color="red">thumb_down_off_alt</v-icon>
                </v-btn>
              </template>
              <span color="white--text">Negativar membro</span>
            </v-tooltip>

            <v-tooltip
              bottom
              dark
              v-if="
                billings.length > 0 &&
                !this.user.group.includes('external_collection')
              "
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  color="tertiary"
                  small
                  icon
                  flat
                  @click="createCancelBillingDialog = true"
                  v-on="on"
                >
                  <v-icon right>price_check</v-icon>
                </v-btn>
              </template>
              <span color="white--text">Gerar fatura de encerramento</span>
            </v-tooltip>
          </v-layout>
        </v-flex>
      </v-layout>
      <div class="text-xs-center pt-5" v-if="loadingBillingCS">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <v-data-table
        v-else
        :headers="headers"
        :items="billings"
        class="elevation-0"
        :loading="loadingBillingCS"
        :search="search"
        rows-per-page-text="Linhas por página"
        :rows-per-page-items="rowsPerPage"
        no-data-text="Não há faturas"
        :pagination.sync="pagination"
      >
        <v-progress-linear
          color="blue"
          indeterminate
          v-if="loading"
        ></v-progress-linear>

        <template v-slot:items="props">
          <td>{{ props.item.competence | competence }}</td>
          <td class="text-xs-right">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span
                  v-on="on"
                  v-if="props.item.lost_discount"
                  style="text-decoration: line-through"
                  >R$ {{ props.item.total | formatCurrency }}</span
                >
                <span v-else>R$ {{ props.item.total | formatCurrency }}</span>
              </template>
              <span
                >Data de Vencimento Original:
                {{ props.item.original_due_date | formatarDate }} <br />Data de
                Vencimento Atual: {{ props.item.due_date | formatarDate }}</span
              >
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-if="props.item.lost_discount" v-on="on">
                  <br />
                  R$
                  {{ props.item.total_without_discount | formatCurrency }}
                </span>
              </template>
              <span>Valor da fatura após perda de economia.</span>
            </v-tooltip>
          </td>
          <td class="text-xs-right">
            <span
              style="text-decoration: line-through"
              v-if="props.item.lost_discount"
              >R$ {{ props.item.discount | formatCurrency }}
            </span>
            <span v-else>R$ {{ props.item.discount | formatCurrency }}</span>
            <span v-if="props.item.lost_discount">
              <br />
              R$ {{ props.item.overdue_discount | formatCurrency }}
            </span>
          </td>
          <td>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  :color="props.item.status | statusColor"
                  @click.prevent="gotoTransactionHistory(props.item.id)"
                >
                  {{ props.item.status | statusIcon }}
                </v-icon>
              </template>
              <span>{{ formatStatus(props.item) || "x" }}</span>
            </v-tooltip>
            <v-tooltip
              v-if="props.item.negativation_id && props.item.status !== 'paid'"
              bottom
            >
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  color="red"
                  @click.prevent="gotoTransactionHistory(props.item.id)"
                >
                  thumb_down_off_alt
                </v-icon>
              </template>
              <span>Negativado</span>
            </v-tooltip>
            <v-tooltip v-if="props.item?.limpa_nome !== undefined" bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-if="props.item?.limpa_nome === true"
                  v-on="on"
                  color="red"
                  @click.prevent="openLimpaNomeDialog(props.item.id)"
                >
                  cleaning_services
                </v-icon>
                <v-icon
                  v-else-if="props.item?.limpa_nome === false"
                  v-on="on"
                  color="green"
                  >cleaning_services</v-icon
                >
              </template>
              <span v-if="props.item?.limpa_nome === false"
                >Limpa nome removido</span
              >
              <span v-else-if="props.item?.limpa_nome === true"
                >Limpa Nome =)</span
              >
            </v-tooltip>
          </td>
        </template>
        <template v-slot:pageText="props">
          Linha {{ props.pageStart }} - {{ props.pageStop }} de
          {{ props.itemsLength }}
        </template>
        <template v-slot:no-results>
          <v-alert :value="true" color="error" icon="warning">
            Sua busca por "{{ search }}" não encontrou resultados.
          </v-alert>
        </template>
      </v-data-table>
      <v-flex
        sm12
        md12
        style="background: #efefef"
        pt-1
        pb-1
        v-if="!loadingBillingCS && billings.length > 0"
      >
        <v-layout justify-space-around align-end>
          <!-- Criar Fatura -->
          <v-tooltip
            bottom
            dark
            v-if="!this.user.group.includes('external_collection')"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                color="tertiary"
                small
                icon
                flat
                @click.prevent="createBillingDialog = true"
                v-on="on"
              >
                <v-icon right>mdi-file-document-box-outline</v-icon>
              </v-btn>
            </template>
            <span color="white--text">Criar fatura</span>
          </v-tooltip>

          <!-- Reenviar Fatura -->
          <v-tooltip
            bottom
            dark
            v-if="!this.user.group.includes('external_collection')"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                color="tertiary"
                small
                icon
                flat
                @click.prevent="resendDialog = true"
                v-on="on"
              >
                <v-icon right>send</v-icon>
              </v-btn>
            </template>
            <span color="white--text">Reenviar fatura</span>
          </v-tooltip>

          <!-- Alterar vencimento -->
          <v-tooltip
            bottom
            dark
            v-if="!this.user.group.includes('external_collection')"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                color="tertiary"
                small
                icon
                flat
                @click.prevent="changeDueDateDialog = true"
                v-on="on"
              >
                <v-icon right>gavel</v-icon>
              </v-btn>
            </template>
            <span color="white--text">Alterar vencimento</span>
          </v-tooltip>

          <!-- A pedidos, não deletar botão de cancelar renegociação abaixo -->

          <!-- Cancelar Renegociação -->
          <!-- <v-tooltip bottom dark>
            <template v-slot:activator="{ on }">
              <v-btn color="tertiary" small icon flat @click.prevent="getRenegociationInvoices" v-on="on">
                <v-icon right>mdi-calendar-remove</v-icon>
              </v-btn>
            </template>
            <span color="white--text">Cancelar negociação</span>
          </v-tooltip> -->

          <!-- Copiar Faturas Atrasadas -->
          <v-tooltip bottom dark>
            <template v-slot:activator="{ on }">
              <v-btn
                color="tertiary"
                small
                icon
                flat
                @click.prevent="copyOverdueBillings"
                v-on="on"
              >
                <v-icon right>content_copy</v-icon>
              </v-btn>
            </template>
            <span color="white--text">Copiar faturas atrasadas</span>
          </v-tooltip>

          <!-- Renegociar/parcelar Fatura -->
          <v-tooltip bottom dark>
            <template v-slot:activator="{ on }">
              <v-btn
                color="tertiary"
                small
                icon
                flat
                @click.prevent="parcelDialog = true"
                v-on="on"
              >
                <v-icon right>list</v-icon>
              </v-btn>
            </template>
            <span color="white--text">Renegociar dívida</span>
          </v-tooltip>

          <v-tooltip
            bottom
            dark
            v-if="!this.user.group.includes('external_collection')"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                color="tertiary"
                small
                icon
                flat
                @click.prevent="abonoDialog = true"
                v-on="on"
              >
                <v-icon right>money_off</v-icon>
              </v-btn>
            </template>
            <span color="white--text">Abonar Fatura(s)</span>
          </v-tooltip>

          <!-- Negativar Faturas -->
          <v-tooltip
            bottom
            dark
            v-if="
              user.partner_id === 'enercred' &&
              !this.user.group.includes('external_collection')
            "
          >
            <template v-slot:activator="{ on }">
              <v-btn
                color="tertiary"
                small
                icon
                flat
                @click.prevent="negativationDialog = true"
                v-on="on"
              >
                <v-icon right color="red">thumb_down_off_alt</v-icon>
              </v-btn>
            </template>
            <span color="white--text">Negativar membro</span>
          </v-tooltip>

          <v-tooltip
            bottom
            dark
            v-if="!this.user.group.includes('external_collection')"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                color="tertiary"
                small
                icon
                flat
                @click.prevent="createCancelBillingProcess()"
                v-on="on"
              >
                <v-icon right>price_check</v-icon>
              </v-btn>
            </template>
            <span color="white--text">Gerar fatura de encerramento</span>
          </v-tooltip>
        </v-layout>
      </v-flex>

      <cpnDetalhesFatura />

      <v-dialog v-model="createBillingDialog" max-width="500px" persistent>
        <v-form>
          <v-card>
            <v-card-title class="headline grey lighten-2"
              >Criar nova fatura</v-card-title
            >
            <v-card-text>
              Selecione a competência da fatura.
              <v-text-field
                prepend-icon="calendar_today"
                v-model="competence"
                label="Competência"
                mask="##/####"
                :rules="competenceRules"
                required
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                flat="flat"
                @click="createBillingDialog = false"
              >
                Cancelar
              </v-btn>
              <v-btn
                color="primary"
                flat="flat"
                @click="generateBilling"
                :loading="loadingNewBilling"
              >
                Gerar fatura
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>

      <v-dialog v-model="resendDialog" max-width="500px" persistent>
        <v-form ref="resend">
          <v-card>
            <v-card-title class="headline grey lighten-2"
              >Reenviar fatura para o membro</v-card-title
            >
            <v-card-text>
              Selecione a fatura para reenviar.
              <v-select
                prepend-icon="flag"
                :items="billings"
                v-model="resendBilling"
                :item-text="selectText"
                return-object
                label="Fatura"
                :rules="[(v) => !!v || 'Por favor selecione uma fatura.']"
                required
              ></v-select>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat="flat" @click="resendDialog = false">
                Cancelar
              </v-btn>
              <v-btn color="primary" flat="flat" @click="resendToClient">
                Reenviar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <v-dialog v-model="rebillingDialog" max-width="550px" persistent>
        <v-form ref="rebilling">
          <v-card>
            <v-card-title class="headline grey lighten-2"
              >Renegociar</v-card-title
            >
            <v-card-text>
              Selecione a(s) fatura(s), a data de vencimento e o tipo de
              pagamento. Caso necessário, é possível retirar a multa e/ou juros
              da nova fatura renegociada.
              <br />
              <v-alert
                :value="true"
                type="warning"
                v-if="this.consumerUnit.unique_billing"
                >Essa fatura está unificada, ao atualizar ou parcelar, será
                desmembrada da conta CEMIG. Orientar ao membro que deverá pagar
                a conta CEMIG, e disponibilizar arquivo se necessário.
                <br /><span class="font-weight-bold"
                  >Ele possui riscos de ter a conta cortada caso não efetive o
                  pagamento.</span
                >
              </v-alert>
              <v-select
                prepend-icon="flag"
                v-model="rebillingBillings"
                :items="
                  billings.filter(
                    (b) =>
                      b.status != 'paid' &&
                      b.status != 'succeeded' &&
                      b.status != 'paga' &&
                      b.status != 'free' &&
                      b.status != 'refunded' &&
                      b.status != 'chargedback' &&
                      b.status != 'reprocessing' &&
                      b.status != 'in_queue' &&
                      b.status != 'parceled',
                  )
                "
                :item-text="selectText"
                no-data-text="Não há faturas para renegociar"
                return-object
                label="Faturas"
                :rules="[
                  (v) =>
                    v.length > 0 || 'Por favor selecione no mínimo uma fatura.',
                ]"
                multiple
                chips
              ></v-select>
              <v-select
                prepend-icon="receipt"
                :items="['credit_card', 'boleto']"
                v-model="rebillingMethod"
                return-object
                label="Meio de pagamento"
                :rules="[
                  (v) => !!v || 'Por favor selecione um meio de pagamento.',
                ]"
                required
              ></v-select>
              <v-layout row wrap v-if="rebillingMethod === 'boleto'">
                <v-dialog
                  ref="dateDialog"
                  v-model="modal"
                  :return-value.sync="rebillingDate"
                  persistent
                  lazy
                  full-width
                  width="450px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="rebillingDate"
                      label="Nova Data de Vencimento"
                      prepend-icon="date_range"
                      readonly
                      v-on="on"
                      :rules="[(v) => !!v || 'Por favor selecione uma data.']"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    dark
                    v-model="rebillingDate"
                    scrollable
                    width="450px"
                    :min="new Date().toISOString()"
                    :max="maxDate"
                  >
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="modal = false"
                      >Cancelar</v-btn
                    >
                    <v-btn
                      flat
                      color="primary"
                      @click="$refs.dateDialog.save(rebillingDate)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-layout>
              <v-layout row wrap v-if="rebillingMethod === 'boleto'">
                <v-flex xs12 lg6>
                  <v-checkbox
                    v-model="rebillingPenalty"
                    :label="`Retirar multa`"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 lg6>
                  <v-checkbox
                    v-model="rebillingInterest"
                    :label="`Retirar juros`"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="rebillingDialog = false">
                Cancelar
              </v-btn>
              <v-btn
                color="primary"
                flat
                @click="saveRebilling"
                :disabled="loadingChange"
                :loading="loadingChange"
              >
                Renegociar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <v-dialog v-model="createCancelBillingDialog" max-width="500px">
        <v-card class="py-3 px-1">
          <v-card-title class="pb-0">
            <div class="title font-weight mx-auto text-xs-center">
              Tem certeza que deseja gerar uma fatura de encerramento?
            </div>
          </v-card-title>
          <v-card-actions>
            <div class="mx-auto">
              <v-btn color="red" text @click="createCancelBillingDialog = false"
                >Cancelar</v-btn
              >
              <v-btn
                color="green"
                text
                @click.prevent="createCancelBillingProcess()"
                >Confirmar</v-btn
              >
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="parcelDialog" max-width="800px" persistent lazy>
        <v-form ref="parcel" v-model="parcel_valid" lazy-validation>
          <v-card>
            <v-card-title class="headline grey lighten-2"
              >Renegociar</v-card-title
            >
            <v-card-text>
              Selecione a(s) fatura(s) e o número de parcelas desejado. O valor
              de cada parcela será adicionado nas próximas faturas do membro.
              <v-alert
                :value="true"
                type="warning"
                v-if="this.consumerUnit.unique_billing"
              >
                Essa fatura está unificada, ao atualizar ou parcelar, será
                desmembrada da conta CEMIG. Orientar ao membro que deverá pagar
                a conta CEMIG, e disponibilizar arquivo se necessário.
                <br /><span class="font-weight-bold"
                  >Ele possui riscos de ter a conta cortada caso não efetive o
                  pagamento.</span
                >
              </v-alert>
              <v-autocomplete
                prepend-icon="flag"
                v-model="parcelBillings"
                :items="
                  billings.filter(
                    (b) =>
                      b.status != 'paid' &&
                      b.status != 'succeeded' &&
                      b.status != 'paga' &&
                      b.status != 'free' &&
                      b.status != 'refunded' &&
                      b.status != 'chargedback' &&
                      b.status != 'reprocessing' &&
                      b.status != 'in_queue' &&
                      b.status != 'negotiated' &&
                      b.status != 'parceled',
                  )
                "
                :item-text="selectText"
                no-data-text="Não há faturas para parcelar"
                return-object
                label="Faturas"
                :rules="parcelBillingsRule"
                multiple
                chips
                required
                @change="parcelSimulated = false"
              ></v-autocomplete>
              Tipo de cobrança:
              <v-flex>
                <v-radio-group
                  v-model="parcelChargeType"
                  row
                  required
                  :rules="[(v) => !!v || 'Informe o tipo de parcelamento.']"
                  @change="resetSimulatedParcels"
                >
                  <v-tooltip
                    bottom
                    v-if="
                      consumerUnit &&
                      consumerUnit.status !== 'canceling' &&
                      consumerUnit.status !== 'canceled' &&
                      consumerUnit.status !== 'interrupting' &&
                      consumerUnit.status !== 'interrupted' &&
                      !consumerUnit.unique_billing
                    "
                  >
                    <template v-slot:activator="{ on }">
                      <v-radio
                        label="Próximas Faturas"
                        value="billing"
                        v-on="on"
                        :disabled="hasNegativationActive"
                      ></v-radio>
                    </template>
                    <div>
                      Parcelas serão cobradas nas próximas faturas geradas
                      conforme faturamento do membro.
                    </div>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-radio
                        label="Boleto(s) Avulso(s)"
                        value="debt_billing"
                        v-on="on"
                      ></v-radio>
                    </template>
                    <div>
                      Parcelas serão cobradas de forma avulsa, com a primeira
                      com vencimento em 7 dias.
                    </div>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-radio
                        label="Pix Avulso(s)"
                        value="debt_billing_pix"
                        v-on="on"
                      ></v-radio>
                    </template>
                    <div>
                      Parcelas serão cobradas de forma avulsa, com a primeira
                      com vencimento em 7 dias.
                    </div>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-radio
                        label="Cartão de Crédito"
                        value="credit_billing"
                        v-on="on"
                      ></v-radio>
                    </template>
                    <div>
                      A negociação será cobrada pelo cartão de crédito à vista
                      ou parcelado.
                    </div>
                  </v-tooltip>
                </v-radio-group>
              </v-flex>
              <v-checkbox
                v-model="parcelPenalty"
                @change="parcelInstallments = []"
                :label="`Retirar juros e multa (apenas para negociação à vista)`"
              ></v-checkbox>
              <div
                v-if="parcelInstallments && parcelInstallments.length > 0"
                class="font-weight-bold"
              >
                Selecione o número de parcelas para realizar a negociação:
              </div>
              <v-radio-group
                v-model="parcelQuantity"
                :mandatory="false"
                hide-details
                column
                style="display: block"
                class="pt-0"
              >
                <v-data-table
                  :headers="headers_installments"
                  :items="parcelInstallments"
                  hide-actions
                  no-data-text="Calcule as parcelas!"
                >
                  <template v-slot:progress>
                    <v-progress-linear
                      color="blue"
                      indeterminate
                    ></v-progress-linear>
                  </template>
                  <template v-slot:items="props">
                    <td
                      v-if="props.item.passed"
                      :class="
                        props.item.num_installments === parcelQuantity
                          ? 'blue lighten-4'
                          : 'white'
                      "
                    >
                      <v-radio
                        class="body-1"
                        :label="props.item.num_installments + 'x'"
                        :value="props.item.num_installments"
                      ></v-radio>
                    </td>
                    <td v-else>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" small>warning</v-icon>
                          <span v-on="on" class="pl-2 grey--text">{{
                            props.item.reason
                          }}</span>
                        </template>
                        <span>
                          Não cumpre regras! Não é possível realizar esse
                          parcelamento com
                          {{ props.item.num_installments }} parcelas.</span
                        >
                      </v-tooltip>
                    </td>
                    <td
                      :class="
                        (!props.item.passed ? 'grey--text ' : '') +
                        (props.item.num_installments === parcelQuantity
                          ? 'blue lighten-4'
                          : 'white') +
                        ' text-xs-right font-weight-bold'
                      "
                    >
                      R$ {{ props.item.installments_value | formatCurrency }}
                    </td>
                    <td
                      :class="
                        (!props.item.passed ? 'grey--text ' : '') +
                        (props.item.num_installments === parcelQuantity
                          ? 'blue lighten-4'
                          : 'white') +
                        ' text-xs-right'
                      "
                    >
                      R$ {{ props.item.total_amount | formatCurrency }}
                    </td>
                  </template>
                  <template v-slot:no-data> Calcule as parcelas! </template>
                </v-data-table>
              </v-radio-group>
              <v-select
                v-if="parcelChargeType === 'credit_billing'"
                prepend-icon="credit_card"
                v-model="selectedCreditCard"
                :items="creditCardsData"
                no-data-text="Não há cartões cadastrados"
                label="Cartões"
                required
                :rules="[
                  (v) => !!v || 'Por favor selecione um cartão de crédito.',
                ]"
              >
                <template v-slot:selection="{ item }">
                  <img height="40px" :src="iconBrand(item)" /> **** **** ****
                  {{ item.last_digits }}
                </template>
                <template v-slot:item="{ item }">
                  <img height="40px" :src="iconBrand(item)" /> **** **** ****
                  {{ item.last_digits }}
                </template>
              </v-select>
              <v-layout
                row
                wrap
                v-if="
                  parcelChargeType === 'debt_billing' ||
                  parcelChargeType === 'debt_billing_pix'
                "
              >
                <v-dialog
                  ref="dateDialog"
                  v-model="modal"
                  :return-value.sync="parcelDueDate"
                  persistent
                  lazy
                  full-width
                  width="450px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="parcelDueDate"
                      label="Selecione a Data de Vencimento da 1a. Parcela"
                      prepend-icon="date_range"
                      readonly
                      v-on="on"
                      :rules="[(v) => !!v || 'Por favor selecione uma data.']"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    dark
                    v-model="parcelDueDate"
                    scrollable
                    width="450px"
                    :min="new Date().toISOString()"
                    :max="maxDate"
                  >
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="modal = false"
                      >Cancelar</v-btn
                    >
                    <v-btn
                      flat
                      color="primary"
                      @click="$refs.dateDialog.save(parcelDueDate)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="primary"
                flat
                @click="
                  parcelDialog = false;
                  parcelSimulated = false;
                "
              >
                Cancelar
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                @click="simulateParcel"
                :disabled="loadingChange || !parcel_valid"
                :loading="loadingChange"
              >
                Calcular
              </v-btn>
              <v-btn
                color="primary"
                flat
                @click="saveParcel"
                :disabled="loadingChange || !parcelSimulated"
                :loading="loadingChange"
              >
                Gerar parcelas
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>

      <v-dialog v-model="abonoDialog" max-width="550px" persistent>
        <v-form ref="changeAbono">
          <v-card>
            <v-card-title class="headline grey lighten-2"
              >Abonar Fatura(s)</v-card-title
            >
            <v-card-text>
              Selecione a(s) fatura(s) para ser(em) abonada(s).
              <v-select
                prepend-icon="flag"
                v-model="setStatusFree"
                :items="
                  billings.filter(
                    (b) =>
                      b.status !== 'paid' &&
                      b.status !== 'succeeded' &&
                      b.status !== 'free' &&
                      b.status !== 'parceled' &&
                      !b.negotiation,
                  )
                "
                :item-text="selectText"
                return-object
                label="Fatura"
                :rules="[(v) => !!v || 'Por favor selecione uma(s) fatura(s).']"
                multiple
                chips
                no-data-text="Não há fatura(s) para abonar"
              ></v-select>
            </v-card-text>
            <v-textarea
              box
              name="free_reason"
              v-model="free_reason"
              placeholder="Escreva o motivo para abonar a(s) fatura(s)"
              :rules="[
                (v) =>
                  !!v ||
                  'Por favor, informe o motivo para abonar a(s) fatura(s).',
              ]"
              required
            ></v-textarea>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="abonoDialog = false">
                Cancelar
              </v-btn>
              <v-btn
                color="primary"
                flat
                @click="changeAbono"
                :loading="loadingChange"
              >
                Abonar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>

      <v-dialog v-model="changeDueDateDialog" max-width="550px" persistent>
        <v-form ref="changeDueDate">
          <v-card>
            <v-card-title class="headline grey lighten-2"
              >Alterar Vencimento</v-card-title
            >
            <v-card-text>
              Selecione a fatura e a nova data de vencimento. Essa operação
              somente irá mudar a data de vencimento de um boleto.
              <v-select
                prepend-icon="flag"
                v-model="changeDueDateBilling"
                :items="
                  billings.filter(
                    (b) =>
                      (b.status === 'overdue' ||
                        b.status === 'waiting_payment') &&
                      !b.negotiation,
                  )
                "
                :item-text="selectText"
                return-object
                label="Fatura"
                :rules="[(v) => !!v || 'Por favor selecione uma fatura.']"
                chips
              ></v-select>
              <v-layout row wrap>
                <v-dialog
                  ref="dateDialog"
                  v-model="modal"
                  :return-value.sync="changeDueDateDate"
                  persistent
                  lazy
                  full-width
                  width="450px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="changeDueDateDate"
                      label="Nova Data de Vencimento"
                      prepend-icon="date_range"
                      readonly
                      v-on="on"
                      :rules="[(v) => !!v || 'Por favor selecione uma data.']"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    dark
                    v-model="changeDueDateDate"
                    scrollable
                    width="450px"
                    :min="new Date().toISOString()"
                    :max="maxDateChangeExpire"
                    :allowed-dates="allowedDates"
                  >
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="modal = false"
                      >Cancelar</v-btn
                    >
                    <v-btn
                      flat
                      color="primary"
                      @click="$refs.dateDialog.save(changeDueDateDate)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="changeDueDateDialog = false">
                Cancelar
              </v-btn>
              <v-btn
                color="primary"
                flat
                @click="changeDueDate"
                :disabled="loadingChange"
                :loading="loadingChange"
              >
                Alterar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <v-dialog v-model="negativationDialog" max-width="550px" persistent>
        <v-form ref="negativation">
          <v-card>
            <v-card-title class="headline red darken-2 white--text"
              >Negativar</v-card-title
            >
            <v-card-text>
              Selecione a(s) fatura(s) que foram enviadas para negativação.
              <v-select
                prepend-icon="flag"
                v-model="negativationBillings"
                :items="
                  billings.filter(
                    (b) =>
                      (b.status === 'overdue' ||
                        b.status === 'canceled' ||
                        b.status === 'negotiated' ||
                        b.status === 'refused') &&
                      !b.negativation_id,
                  )
                "
                :item-text="selectText"
                no-data-text="Não há faturas para negativar"
                return-object
                label="Faturas"
                :rules="[
                  (v) =>
                    v.length > 0 || 'Por favor selecione no mínimo uma fatura.',
                ]"
                multiple
                chips
              ></v-select>
              <v-flex
                v-if="
                  negativationBillings
                    .map((b) => b.status)
                    .some((el) => el == 'refused' || el == 'negotiated')
                "
                class="orange--text"
              >
                Existem faturas selecionadas que não estão atrasadas ou
                expiradas. Verifique se realmente foram enviadas para
                negativação.
              </v-flex>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="negativationDialog = false">
                Cancelar
              </v-btn>
              <v-btn
                color="red"
                @click="saveNegativation(negativationBillings)"
                :disabled="loadingChange"
                :loading="loadingChange"
              >
                Negativar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <v-dialog
        v-model="cancelRenegotiationDialog"
        max-width="550px"
        persistent
      >
        <v-form ref="cancelRenegotiation">
          <v-card>
            <v-card-title class="headline grey lighten-2"
              >Cancelamento de renegociação</v-card-title
            >
            <v-card-text>
              Selecione a fatura que deseja cancelar a renegociação.
              <v-select
                prepend-icon="flag"
                v-model="invoiceToCancelRenegotiationSelected"
                :items="invoicesToCancelRenegotiation"
                :item-text="renegociationInvoicesFormated"
                no-data-text="Não há faturas em renegociação passivas de serem canceladas."
                label="Faturas em renegociação"
                return-object
                single-line
                chips
              ></v-select>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                flat
                @click="cancelRenegotiationDialog = false"
              >
                Voltar
              </v-btn>
              <v-btn
                color="red"
                @click="
                  renegociationToCancelSelected(invoicesToCancelRenegotiation)
                "
                :disabled="loadingChange"
                :loading="loadingChange"
              >
                Cancelar renegociação
              </v-btn>
              <v-dialog
                v-model="invoiceToCancelRenegotiationModal"
                max-width="450"
              >
                <v-card>
                  <v-card-title class="headline red lighten-2 white--text">
                    <v-icon color="white darken-2 pr-2" large
                      >mdi-alert-circle-outline</v-icon
                    >
                    <span class="ml-2">Confirmação de cancelamento</span>
                  </v-card-title>
                  <v-spacer></v-spacer>
                  <v-card-text>
                    Ao confirmar o cancelamento desta fatura em negociação a(s)
                    seguinte(s) fatura(s) serão deletadas permanentemente:
                    <br /><br />
                    <v-badge>{{
                      invoiceToCancelRenegotiationModalMessage
                    }}</v-badge>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      class="grey darken-1"
                      @click="invoiceToCancelRenegotiationModal = false"
                    >
                      Fechar
                    </v-btn>
                    <v-btn
                      color="red darken-1"
                      text
                      @click="deleteRenegociationPerMasterId"
                    >
                      Confirmar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>

      <v-dialog v-model="limpaNome.dialog" max-width="500">
        <v-card>
          <v-card-title class="headline red lighten-2 white--text">
            <v-icon color="white darken-2 pr-2" large
              >mdi-alert-circle-outline</v-icon
            >
            <span class="ml-2">Remoção do Limpa Nome</span>
          </v-card-title>
          <v-spacer></v-spacer>
          <v-card-text>
            Deseja remover de fato esta fatura do limpa nome?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="red darken-1" @click="limpaNome.dialog = false">
              Fechar
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              @click="removeLimpaNome(limpaNome.billingId)"
            >
              Confirmar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar
        v-model="snackbar.value"
        :multi-line="snackbar.mode === 'multi-line'"
        :timeout="snackbar.timeout"
        :top="snackbar.top"
        :color="snackbar.color"
      >
        {{ snackbar.message }}
        <v-btn color="white" flat @click="snackbar.value = false">Fechar</v-btn>
      </v-snackbar>
    </v-container>
  </v-card>
</template>

<script>
import { eventBus } from "@/main";
import moment from "moment";
import { mapActions, mapGetters, mapState } from "vuex";
import firestore from "../../../firebase/firestore";
import { calendarMixin } from "../../../mixin/calendarMixin";
import {
  changeDueDate,
  createCancelBilling,
  emptyBilling,
  parcel,
  rebilling,
  removeTransaction,
  sendInvoice,
  simulateAllParcel,
  updateBilling,
} from "../../../services/billing";
import { getPermission } from "../../../services/permissions";
import { saveAnalytics } from "../../../services/save_analytics";
import { getCards } from "../../../services/support/cards";
import api from "../../../utils/api";
import DetalhesFatura from "../../faturaDetails/DetalhesFatura";

export default {
  props: ["consumerUnit"],

  components: { cpnDetalhesFatura: DetalhesFatura },
  mixins: [calendarMixin],

  data() {
    return {
      loadingChange: false,
      loadingNewBilling: false,
      checkbox: true,
      competence: "",
      invoicesToCancelRenegotiation: [],
      invoiceToCancelRenegotiationSelected: null,
      invoiceToCancelRenegotiationSelectedMaster: null,
      invoiceToCancelRenegotiationSelectedCompetences: null,
      invoiceToCancelRenegotiationModal: false,
      invoiceToCancelRenegotiationModalMessage: "",
      createBillingDialog: false,
      resendDialog: false,
      rebillingDialog: false,
      parcelDialog: false,
      abonoDialog: false,
      negativationDialog: false,
      cancelRenegotiationDialog: false,
      changeDueDateDialog: false,
      resendBilling: null,
      rebillingBilling: null,
      rebillingMethod: null,
      rebillingDate: "",
      rebillingPenalty: false,
      rebillingInterest: false,
      parcelPenalty: true,
      rebillingBillings: [],
      parcelBillings: [],
      parcelQuantity: 2,
      parcelInstallments: [],
      parcelDueDate: "",
      parcelSimulated: false,
      parcelChargeType: null,
      creditCardsData: [],
      selectedCreditCard: null,
      negativationBillings: [],
      changeDueDateBilling: null,
      setStatusFree: [],
      free_reason: "",
      changeDueDateDate: "",
      rowsPerPage: [12, 24],
      modal: false,
      search: "",
      maxDateChangeExpire: "",
      parcel_valid: false,
      createCancelBillingDialog: false,
      competenceRules: [
        (v) =>
          !(v.substr(2, 4) < 2019) ||
          !v ||
          "Por favor, o ano deve ser valido. " + v.substr(2, 4),
        (v) =>
          !(v.substr(0, 2) > 12) ||
          !v ||
          "Por favor, o mes deve ser valido. " + v.substr(0, 2),
      ],
      parcelBillingsRule: [
        (v) => {
          if (v.length >= 1) return true;
          else return "Selecione no mínimo 1 fatura.";
        },
      ],
      parcelInstallmentsRule: [
        (v) => {
          if (parseFloat(v) >= 50) return true;
          else return "Valor de cada parcela deve ser de no mínimo R$50,00";
        },
      ],
      renegotiationURL: process.env.VUE_APP_REBILLING,
      headers: [
        {
          text: "Competência",
          align: "left",
          sortable: true,
          value: "competence",
        },
        {
          text: "Valor",
          align: "right",
          value: "total",
        },
        {
          text: "Economia",
          align: "right",
          value: "discount",
        },
        { text: "", value: "status" },
      ],
      headers_installments: [
        { text: "Parcela", value: "competence", sortable: false },
        {
          text: "Valor Parcela",
          value: "installments_value",
          align: "right",
          sortable: false,
        },
        {
          text: "Valor Total",
          value: "total_amount",
          align: "right",
          sortable: false,
        },
      ],
      pagination: {
        sortBy: "competence",
        descending: true,
        rowsPerPage: 10,
      },
      snackbar: {
        timeout: 6000,
        value: false,
        message: "",
        color: "",
        top: false,
        botton: false,
        mode: "",
      },
      loading: true,
      actions: [
        {
          title: "Reenviar",
          icon: "send",
          action: this.resendDialog,
          color: "",
          outline: true,
        },
        {
          title: "Renegociar",
          icon: "send",
          action: this.rebillingDialog,
          color: "",
          outline: true,
        },
        {
          title: "Parcelar",
          icon: "send",
          action: this.parcelDialog,
          color: "",
          outline: true,
        },
        {
          title: "Negativar",
          icon: "send",
          action: this.negativationDialog,
          color: "red",
          outline: false,
        },
      ],
      limpaNome: {
        dialog: false,
        billingId: "",
      },
    };
  },

  computed: {
    ...mapGetters("cs", [
      "billings",
      "userCS",
      "hasNegativationActive",
      "NegativationsActive",
    ]),
    ...mapState("cs", ["activeBilling", "loadingBillingCS", "negativations"]),
    ...mapState(["config", "user", "permissions"]),

    maxDate() {
      const date = new Date();
      date.setDate(date.getDate() + 30);
      return date.toISOString();
    },

    parcelSum() {
      if (this.parcelBillings.length) {
        return this.parcelBillings.reduce((a, b) => a + b.total, 0);
      }
      return 0;
    },

    isAdmin() {
      let currentUserGroups = this.user.group.toString();
      return currentUserGroups.indexOf("admin") >= 0;
    },

    isFinancial() {
      let currentUserGroups = this.user.group.toString();
      return currentUserGroups.indexOf("financial") >= 0;
    },
  },

  async mounted() {
    const customer_id = this?.billings[0]?.customer_id;

    const cards = (
      await firestore.collection("users").doc(customer_id).get()
    )?.data()?.cards;

    if (cards) {
      const cardsData = await getCards(cards);
      this.creditCardsData = cardsData.map((item) => {
        return {
          value: item.data.id,
          brand: item.data.brand,
          last_digits: item.data.last_digits,
        };
      });
    }
    if (this.isAdmin || this.isFinacial) {
      const date = new Date();
      const config_date = (
        await firestore.collection("config").doc("segunda_via").get()
      ).data().max_days_admin;
      date.setDate(date.getDate() + (config_date ?? 60));
      this.maxDateChangeExpire = date.toISOString();
    } else {
      const date = new Date();
      const config_date = (
        await firestore.collection("config").doc("segunda_via").get()
      ).data().max_days_internal;
      date.setDate(date.getDate() + (config_date ?? 15));
      this.maxDateChangeExpire = date.toISOString();
    }
  },

  filters: {
    competence(value) {
      if (!value) return "";
      let comp = value.split("-");
      return comp[1] + "/" + comp[0];
    },

    statusIcon(value) {
      if (!value) return "";
      if (value === "paid" || value === "succeeded") {
        return "done";
      } else if (value === "refused") {
        return "error";
      } else if (value === "generating") return "hourglass_top";
      else if (value === "opened" || value === "waiting_payment")
        return "schedule";
      else if (value === "canceled") return "watch_later";
      else if (value === "overdue") return "alarm";
      else if (value === "generation_failed") return "report_problem";
      else if (value === "validation_failed") return "report_problem";
      else if (value === "free") return "card_giftcard";
      else if (value === "error") return "error";
      else if (value === "reprocessing") return "history";
      else if (value === "pending_approval") return "pending_actions";
      else if (value === "in_queue") return "history_toggle_off";
      else if (value === "refunded") return "keyboard_return";
      else if (value === "negotiated") return "gavel";
      else if (value === "parceled") return "list";
      else if (value === "free_pending") return "card_giftcard";
      else if (value === "postponed") return "currency_exchange";
      else {
        return "alarm";
      }
    },

    statusColor(value) {
      if (!value) return "";
      if (value === "paid" || value === "succeeded") {
        return "green";
      } else if (value === "refused") {
        return "orange";
      } else if (value === "generating") return "blue";
      else if (value === "opened" || value === "waiting_payment") return "grey";
      else if (value === "canceled") return "black";
      else if (value === "overdue") return "red";
      else if (value === "generation_failed") return "orange";
      else if (value === "validation_failed") return "orange";
      else if (value === "free") return "blue";
      else if (value === "reprocessing") return "red";
      else if (value === "pending_approval") return "blue";
      else if (value === "error") return "red";
      else if (value === "in_queue") return "blue";
      else if (value === "refunded") return "blue";
      else if (value === "negotiated") return "blue-grey";
      else if (value === "parceled") return "blue-grey";
      else if (value === "postponed") return "#FFD700";
      else {
        return "grey";
      }
    },

    formatCurrency(value) {
      if (value === undefined || value === null) return "-";
      let val = (value * 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },

  methods: {
    ...mapActions("cs", ["getBillings"]),

    gotoTransactionHistory(transaction_id) {
      eventBus.$emit("billing_id", transaction_id);
      eventBus.$emit("right", true);
    },

    async generateBilling() {
      const competence = `${this.competence.substring(
        2,
      )}-${this.competence.substring(0, 2)}`;
      const consumer_unit = this.consumerUnit.id;
      this.loadingNewBilling = true;

      await emptyBilling(competence, consumer_unit)
        .then(() => {
          this.createBillingDialog = false;
          this.loadingNewBilling = false;
          this.showSnackBar("Fatura gerada com sucesso!", "top", "green");
        })
        .catch((err) => {
          this.createBillingDialog = false;
          this.loadingNewBilling = false;
          this.showSnackBar(
            "Erro ao gerar fatura. " + err.response.data.message,
            "top",
            "red",
          );
          console.error(err);
        });
    },

    async resendToClient() {
      if (!this.$refs["resend"].validate()) {
        return false;
      }
      this.loadingChange = true;
      await sendInvoice(this.resendBilling.id, localStorage.getItem("token"))
        .then(() => {
          this.resendDialog = false;
          this.loadingChange = false;
          this.showSnackBar(
            "Pedido de reenvio salvo com sucesso!",
            "top",
            "green",
          );
        })
        .catch((err) => {
          this.resendDialog = false;
          this.loadingChange = false;
          this.showSnackBar(
            "Erro ao pedir reenvio de fatura. Tente novamente mais tarde. " +
              err,
            "top",
            "red",
          );
          console.error(err);
        });
    },

    async saveRebilling() {
      if (!this.$refs["rebilling"].validate()) {
        return false;
      }
      this.loadingChange = true;
      await rebilling(
        this.rebillingBillings.map((b) => b.id),
        this.rebillingMethod,
        this.rebillingDate,
        this.rebillingPenalty,
        this.rebillingInterest,
      )
        .then(() => {
          this.rebillingDialog = false;
          this.loadingChange = false;
          const analytics = {
            eventCategory: "BILLING",
            eventAction: "BILLING_REPROCESSED",
            eventLabel: "NEGOCIATED_" + this.rebillingMethod,
            user_id: this.user.email,
            agent: this.user.email,
            boleto: false,
          };
          saveAnalytics(analytics);
          this.showSnackBar(
            "Pedido de renegociação feito com sucesso!",
            "top",
            "green",
          );
        })
        .catch((err) => {
          this.rebillingDialog = false;
          this.loadingChange = false;
          this.showSnackBar("Erro ao fazer renegociação. " + err, "top", "red");
          console.error("------>", err);
        });
    },

    resetSimulatedParcels() {
      this.parcelInstallments = [];
      this.num_installment = null;
    },

    simulateParcel() {
      if (this.$refs["parcel"].validate()) {
        console.log("parcelBillings: ", this.parcelBillings);
        if (!this.parcelChargeType && this.parcelBillings.length <= 0) {
          this.showSnackBar(
            "Por favor selecione o tipo de cobrança.",
            "top",
            "orange",
          );
          return;
        }
        this.loadingChange = true;
        simulateAllParcel(
          this.parcelBillings.map((b) => b.id),
          this.parcelChargeType,
          this.parcelPenalty,
          this.parcelPenalty,
        )
          .then((res) => {
            console.log("res", res);
            this.parcelInstallments = res.data;
            this.parcelSimulated = true;
            this.loadingChange = false;
          })
          .catch((err) => {
            this.loadingChange = false;
            const error = err.response.data
              ? err.response.data.error
              : err.message;
            const message = err.response ? error : err.message;
            console.error(message);
            this.showSnackBar(
              "Erro ao calcular parcelamento. " + message,
              "top",
              "red",
            );
          });
      }
    },

    async saveParcel() {
      if (!this.$refs["parcel"].validate()) {
        return false;
      }
      this.loadingChange = true;
      let removePenalty = false;
      let removeInterest = false;
      if (this.parcelQuantity === 1) {
        removePenalty = this.parcelPenalty;
        removeInterest = this.parcelPenalty;
        console.log("removePenalty: ", removePenalty);
        console.log("removePenalty", removeInterest);
      }
      await parcel(
        this.parcelBillings.map((b) => b.id),
        this.parcelQuantity,
        this.parcelChargeType,
        this.parcelDueDate,
        removePenalty,
        removeInterest,
        null,
        null,
        null,
        this.selectedCreditCard,
      )
        .then(() => {
          this.parcelDialog = false;
          this.loadingChange = false;
          this.parcelBillings = [];
          this.parcelSimulated = false;
          this.showSnackBar(
            "Pedido de parcelamento feito com sucesso!",
            "top",
            "green",
          );
          const analytics = {
            eventCategory: "BILLING",
            eventAction: "INSTALLED_INVOICE",
            eventLabel: "NEGOCIATED_" + this.parcelQuantity,
            user_id: this.user.email,
            agent: this.user.email,
            boleto: false,
            parcelQuantity: Number(this.parcelQuantity),
          };
          saveAnalytics(analytics);
          this.parcelQuantity = 2;
        })
        .catch((err) => {
          this.parcelDialog = false;
          this.loadingChange = false;
          const error = err.response.data
            ? err.response.data.error
            : err.message;
          const message = err.response ? error : err.message;
          console.error(message);
          this.showSnackBar(
            "Erro ao realizar parcelamento. " + message,
            "top",
            "red",
          );
        });
    },

    async saveNegativation(billingsParam) {
      for (
        let billingIterator = 0;
        billingIterator <= billingsParam.length;
        billingIterator++
      ) {
        let billing = billingsParam[billingIterator];

        if (billing.id) {
          let negativationBillingsData = {
            billing_id: billing.id,
            competence: billing.competence,
            consumer_unit: billing.consumer_unit,
            created_at: new Date(),
            created_by: this.user.email,
            status: "sent",
            status_billing: billing.status,
            total: billing.total,
            transaction_id: billing.transaction.id,
            updated_at: new Date(),
          };

          if (
            billing.payment_service === "boletosimples" &&
            billing.transaction
          ) {
            negativationBillingsData.due_date = billing.transaction.expire_at;
          } else if (
            billing.transaction &&
            billing.payment_service === "pagarme" &&
            billing.transaction.payment_method === "boleto"
          ) {
            negativationBillingsData.due_date =
              billing.transaction.boleto_expiration_date;
          } else if (
            billing.transaction &&
            billing.payment_service === "pagarme" &&
            billing.transaction.payment_method !== "boleto"
          ) {
            negativationBillingsData.due_date =
              billing.transaction.boleto_date_updated;
          }

          await firestore
            .collection("users")
            .doc(billing.customer_id)
            .collection("negativation")
            .add(negativationBillingsData)
            .then(async (res) => {
              await firestore
                .collection("billing")
                .doc(billing.id)
                .update({
                  negativation_id: res.id,
                  negativation_at: new Date(),
                })
                .then(() => {
                  this.negativationDialog = false;
                  this.loadingChange = false;
                  this.showSnackBar(
                    "Unidade negativada com sucesso!",
                    "bottom",
                    "green",
                  );

                  const analytics = {
                    eventCategory: "BILLING",
                    eventAction: "NEGATIVATION",
                    eventLabel: "NEGATIVATION",
                    user_id: this.user.email,
                    agent: this.user.email,
                    competence: billing.competence,
                    consumer_unit: billing.consumer_unit,
                    power_plant_id: billing.power_plant_id,
                    boleto: false,
                  };
                  saveAnalytics(analytics);
                })
                .catch((err) => {
                  this.negativationDialog = false;
                  this.loadingChange = false;
                  this.showSnackBar(
                    "Negotivação criada com sucesso porém não atualizada na fatura, comunicar time de TI, informando a fatura negativada!",
                    "top",
                    "red",
                  );
                  console.error(err.response.data.error);
                });
            })
            .catch((err) => {
              this.negativationDialog = false;
              this.loadingChange = false;
              this.showSnackBar(
                "Erro realizar a operação de negativação!" +
                  err.response.data.error.message,
                "top",
                "red",
              );
              console.error(err.response.data.error);
            });
        }
      }
    },

    async changeAbono() {
      try {
        this.loadingChange = true;
        const permission = await getPermission("change_abono", this.user.id);

        if (!permission.data.has_permission) {
          this.showSnackBar(
            "Usuário sem permissão para realizar essa ação",
            "top",
            "red",
          );
          this.loadingChange = false;
          return false;
        }
      } catch (err) {
        this.loadingChange = false;
        this.showSnackBar(
          "Falha ao consultar permissão do usuário",
          "top",
          "red",
        );
        console.error("Falha ao consultar permissão", err);
        return false;
      }

      if (!this.$refs["changeAbono"].validate()) {
        return false;
      }

      const billing_ids = this.setStatusFree.map((b) => b.id);
      this.loadingChange = true;
      for (let billingID of billing_ids) {
        try {
          await firestore.collection("billing").doc(billingID).update({
            status: "free",
            free_reason: this.free_reason,
            free_approved_at: new Date(),
            free_approved_by: this.user.email,
            updated_at: new Date(),
          });
          removeTransaction(billingID);
        } catch (err) {
          this.abonoDialog = false;
          this.loadingChange = false;
          this.showSnackBar(
            "Erro ao abonar fatura(s). " + err.response.data.error.message,
            "top",
            "red",
          );
          console.error(err.response.data.error);
        }
      }
      this.abonoDialog = false;
      this.loadingChange = false;
      this.showSnackBar("Fatura(s) abonada(s) com sucesso!", "top", "green");
    },

    async changeDueDate() {
      if (!this.$refs["changeDueDate"].validate()) {
        return false;
      }
      this.loadingChange = true;
      await changeDueDate(this.changeDueDateBilling.id, this.changeDueDateDate)
        .then(() => {
          this.changeDueDateDialog = false;
          this.loadingChange = false;
          this.showSnackBar(
            "Data de vencimento alterada com sucesso!",
            "top",
            "green",
          );
        })
        .catch((err) => {
          this.changeDueDateDialog = false;
          this.loadingChange = false;
          this.showSnackBar(
            "Erro ao alterar data de vencimento. " +
              err.response.data.error.message,
            "top",
            "red",
          );
          console.error(err.response.data.error);
        });
    },

    getRenegociationInvoices() {
      let url = process.env.VUE_APP_REBILLING + "/" + this.consumerUnit.id;
      api
        .get(url)
        .then((response) => {
          console.log("RENEGOCIATION INVOICES LIST:", response.data);
          for (let invoice_item in response.data) {
            this.invoicesToCancelRenegotiation.push(
              response.data[invoice_item],
            );
          }
          console.log(
            "invoicesToCancelRenegotiation:",
            this.invoicesToCancelRenegotiation,
          );
        })
        .catch((error) => {
          console.error("RENEGOCIATION INVOICES LIST ERROR: " + error);
        });
      this.cancelRenegotiationDialog = true;
    },

    deleteRenegociationPerMasterId() {
      let url = process.env.VUE_APP_REBILLING;
      let options = {
        data: { billing_id: this.invoiceToCancelRenegotiationSelectedMaster },
      };
      api
        .delete(url, options)
        .then(() => {
          this.showSnackBar(
            "Renegociação cancelada com sucesso",
            "top",
            "green",
          );
        })
        .catch((error) => {
          console.error("RENEGOCIATION INVOICE DELETION ERROR: " + error);
          this.showSnackBar(
            "Erro ao cancelar renegociação. Tente novamente mais tarde.",
            "top",
            "red",
          );
        });
      setTimeout(() => {
        this.invoiceToCancelRenegotiationModal = false;
      }, 2000);
      setTimeout(() => {
        this.cancelRenegotiationDialog = false;
      }, 2000);
    },

    renegociationToCancelSelected() {
      this.invoiceToCancelRenegotiationModal = true;
      this.invoiceToCancelRenegotiationSelectedMaster =
        this.invoiceToCancelRenegotiationSelected.negotiation_master;
      console.log(
        "INVOICE NEGOCIATION TO CANCEL SELECTED IS: " +
          this.invoiceToCancelRenegotiationSelectedMaster,
      );
      let billingsIds = [];
      let returnedMessage = "";
      const billingsNumber =
        this.invoiceToCancelRenegotiationSelected.billing_ids.length;
      for (let iterator = 0; iterator < billingsNumber; iterator++) {
        billingsIds.push(
          this.invoiceToCancelRenegotiationSelected.billing_ids[iterator],
        );
      }
      for (const billingID of billingsIds) {
        let invoiceName = String(billingID);
        returnedMessage += ` <<< Competência: ${
          this.invoiceToCancelRenegotiationSelected[invoiceName].competence
        } - Valor: R$ ${this.invoiceToCancelRenegotiationSelected[
          invoiceName
        ].total.toFixed(2)} >>>`;
      }
      this.invoiceToCancelRenegotiationModalMessage = returnedMessage;
    },

    showSnackBar(msg, direction, color) {
      this.snackbar.message = msg;
      this.snackbar.top = direction === "top";
      this.snackbar.botton = direction === "botton";
      this.snackbar.color = color;
      this.snackbar.value = true;
    },

    selectText(item) {
      return (
        item.competence +
        " — R$" +
        (item.total || 0).toFixed(2) +
        " — " +
        this.formatStatus(item)
      );
    },

    iconBrand(item) {
      if (item.brand === "visa") return "../../../icons/cards/visa.svg";
      if (item.brand === "mastercard")
        return "../../../icons/cards/mastercard.svg";
      if (item.brand === "elo") return "../../../icons/cards/elo.svg";
      else return "../../../icons/cards/unknown.svg";
    },

    renegociationInvoicesFormated(item) {
      return (
        "Vence em: " +
        moment(item.due_date).format("DD/MM/YYYY") +
        " — R$" +
        item.total_deal.toFixed(2) +
        " — com " +
        item.billing_ids.length +
        " fatura(s)."
      );
    },

    formatStatus(billing) {
      let tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() - 1);

      if (billing.status === "") return "xxx";
      else if (billing.status === "paid" || billing.status === "succeeded")
        return "Paga";
      else if (billing.status === "pending") return "Processar";
      else if (billing.status === "refused") return "Recusada";
      else if (billing.status === "pending_approval") return "Em Análise";
      else if (billing.status === "reprocessing") return "Reprocessando";
      else if (billing.status === "generating") return "Gerando";
      else if (billing.status === "opened") return "Aberto";
      else if (billing.status === "canceled") return "Expirado";
      else if (billing.status === "overdue") return "Atrasada";
      else if (billing.status === "generation_failed") return "Falha ao gerar";
      else if (billing.status === "validation_failed") return "Inválido";
      else if (billing.status === "in_queue") return "Programado";
      else if (billing.status === "error") return "Erro";
      else if (billing.status === "free") return "Abonado";
      else if (billing.status === "refunded") return "Reembolsado";
      else if (billing.status === "negotiated") return "Negociado";
      else if (billing.status === "parceled") return "Parcelado";
      else if (billing.status === "waiting_payment") return "Aberta";
      else if (billing.status === "free_pending") return "Pendente para Abono";
      else if (billing.status === "postponed")
        return "O valor da fatura será cobrado nas próximas faturas";
      else return billing.status;
    },

    copyOverdueBillings() {
      const overdueBillings = this.billings.filter(
        (billing) => billing.status === "overdue",
      );

      if (overdueBillings.length <= 0) {
        this.showSnackBar("Membro não possui faturas atrasadas!", "top", "red");
        return;
      }
      let overdueBillingsText = "";
      for (const billing of overdueBillings) {
        let splitCompetence = billing.competence.split("-");
        let formattedCompetence = splitCompetence[1] + "/" + splitCompetence[0];
        let formattedTotal = "R$ " + billing.total.toFixed(2).replace(".", ",");
        overdueBillingsText +=
          formattedCompetence + " - " + formattedTotal + "\n";
      }

      navigator.clipboard.writeText(overdueBillingsText);
      this.showSnackBar("Copiado para área de transferência", "top", "green");
    },

    async createCancelBillingProcess() {
      await createCancelBilling({
        consumer_unit: this.consumerUnit.id,
        cancel_billing_requested_by: this.user.email,
      })
        .then(() => {
          this.showSnackBar("Criado fatura de encerramento!", "top", "green");
          this.createCancelBillingDialog = false;
        })
        .catch((err) => {
          this.showSnackBar(
            "Erro ao criar fatura de encerramento. " + err.response.data.error,
            "top",
            "red",
          );
        });
    },

    openLimpaNomeDialog(billingId) {
      this.limpaNome.dialog = true;
      this.limpaNome.billingId = billingId;
    },

    removeLimpaNome(billingId) {
      updateBilling(billingId, {
        limpa_nome: false,
        remove_limpa_nome_agent: this.user.email,
        removed_limpa_nome_at: new Date(),
      })
        .then(() => {
          this.limpaNome.dialog = false;
          this.showSnackBar("Limpa nome removido com sucesso!", "top", "green");
        })
        .catch((err) => {
          this.limpaNome.dialog = false;
          this.showSnackBar(
            "Erro ao remover fatura do limpa nome",
            "top",
            "red",
          );
          console.error(err);
        });
    },
  },
};
</script>
